module.exports = __webpack_public_path__ + "img/pointer.492282fa.svg";